import React from 'react'

const GradientBlock = ({ children, additionalClassName = 'gradient-block--blue' }) => {
  return (
    <div className={`gradient-block ${additionalClassName}`}>{children}</div>
  )
}

export default GradientBlock
